import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { PageSection, SectionHeader, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { Fragment, memo } from 'react';
import { getLocalizedImages } from './getLocalizedImages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GridRowLayout = ({
  reverse,
  description,
  image
}) => {
  const currentOrder = reverse ? [description, image] : [image, description];
  return /*#__PURE__*/_jsx(Fragment, {
    children: currentOrder.map((item, index) => {
      return /*#__PURE__*/_jsx(PPUIGridItem, {
        children: item
      }, `item-${index}`);
    })
  });
};
const keyFeatures = {
  'breeze-intelligence': ['dataEnrichment', 'smartProperties', 'buyerIntent'],
  'hubspot-credits': ['instant247Support', 'trustedResponses', 'seamlessSupport']
};
const UBBKeyFeatures = ({
  navItem
}) => {
  const isMaxWidthTablet = useMedia('tablet');
  const features = keyFeatures[navItem];
  if (!features) return null;
  return /*#__PURE__*/_jsxs(PageSection, {
    hideOverflow: false,
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      maxInlineSize: "100%",
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `pricingPage.pages.${navItem}.keyFeatures.title`
        })
      })
    }), /*#__PURE__*/_jsx(PPUIGrid, {
      gridTemplateColumns: isMaxWidthTablet ? '1fr' : '1fr 1fr',
      rowGap: isMaxWidthTablet ? '1400' : '1500',
      alignItems: "center",
      justifyItems: "center",
      children: features.map((feature, index) => {
        return /*#__PURE__*/_jsx(GridRowLayout, {
          reverse: !isMaxWidthTablet && index % 2 === 1,
          image: /*#__PURE__*/_jsx(Image, {
            src: getLocalizedImages(feature)
          }),
          description: /*#__PURE__*/_jsxs(View, {
            marginInlineStart: index % 2 === 0 ? '800' : '0',
            marginInlineEnd: index % 2 === 0 ? '0' : '800',
            marginInline: isMaxWidthTablet ? '0 !important' : undefined,
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h3",
              typography: "heading-100",
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `pricingPage.pages.${navItem}.keyFeatures.features.${feature}.title`
              })
            }), /*#__PURE__*/_jsx(Text, {
              as: "p",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `pricingPage.pages.${navItem}.keyFeatures.features.${feature}.description`
              })
            })]
          })
        }, `row-${index}`);
      })
    })]
  });
};
export default /*#__PURE__*/memo(UBBKeyFeatures);